export const ROUTES = {
  BARRIERS: '/barriers',
  ROUTES: '/routes',
  DASHBOARD: '/dashboard',
  STATS: '/stats',
  INDUSTRIAL_REF_BOOK: '/industrial-ref-book',
  NOT_FOUND: '/404',
} as const;

/** Virtual top-menu tab that owns the `/routes` and `/barriers` URLs. */
export const MAP_TAB = 'map' as const;
export type MapTab = typeof MAP_TAB;

export const WORKSPACE_ROUTES: readonly string[] = [
  ROUTES.BARRIERS,
  ROUTES.ROUTES,
];
